// extracted by mini-css-extract-plugin
module.exports = {"back":"organizationChoice_back__Z1wC2"};